import {createSelector} from '@reduxjs/toolkit';
import type {Store} from 'store';

const x = (store: Store) => store;

export const getQuickShareByFileId = (fileId: string) =>
  createSelector(x, store =>
    store.quickShare.list.find(qs => qs.node.id === fileId),
  );
